import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { useLanguage } from '../../../../../contexts/LanguageContext';
import { useModuleOptions, useUserTypeOptions } from './RoleSettingsForm';

const EMPTY = { name: '', description: '', moduleCode: null, priority: 10, assignableUserType: null };
// Identity rol adı teknik isimdir (boşluksuz, ASCII); ekranda açıklama gösterilir
const NAME_PATTERN = /^[A-Za-z][A-Za-z0-9_]{2,63}$/;

const CreateRoleDialog = ({ visible, catalog, saving, onHide, onCreate }) => {
    const { th } = useLanguage();
    const [values, setValues] = useState(EMPTY);
    const [submitted, setSubmitted] = useState(false);
    const moduleOptions = useModuleOptions(catalog);
    const userTypeOptions = useUserTypeOptions();

    useEffect(() => {
        if (visible) {
            setValues(EMPTY);
            setSubmitted(false);
        }
    }, [visible]);

    const change = (field, value) => setValues((prev) => ({ ...prev, [field]: value }));
    const nameInvalid = !NAME_PATTERN.test(values.name);

    const submit = () => {
        setSubmitted(true);
        if (nameInvalid) return;
        onCreate(values);
    };

    const footer = (
        <div>
            <Button type="button" label={th('common.cancel')} icon="pi pi-times" outlined onClick={onHide} disabled={saving} />
            <Button type="button" label={th('common.save')} icon="pi pi-check" onClick={submit} loading={saving} />
        </div>
    );

    return (
        <Dialog header={th('authorizationV2.role.newRole')} visible={visible} onHide={onHide} footer={footer} style={{ width: '40rem' }} breakpoints={{ '768px': '95vw' }} modal>
            <div className="grid formgrid p-fluid">
                <div className="field col-12">
                    <label htmlFor="newRoleName" className="font-bold">
                        {th('authorizationV2.role.name')}*
                    </label>
                    <InputText id="newRoleName" value={values.name} onChange={(e) => change('name', e.target.value.trim())} className={submitted && nameInvalid ? 'p-invalid' : ''} placeholder="WarrantyServiceManager" />
                    <small className={submitted && nameInvalid ? 'p-error' : 'text-color-secondary'}>{th('authorizationV2.role.nameHint')}</small>
                </div>
                <div className="field col-12">
                    <label htmlFor="newRoleDescription" className="font-bold">
                        {th('authorizationV2.role.description')}
                    </label>
                    <InputText id="newRoleDescription" value={values.description} onChange={(e) => change('description', e.target.value)} maxLength={256} />
                </div>
                <div className="field col-12 md:col-6">
                    <label htmlFor="newRoleModule" className="font-bold">
                        {th('authorizationV2.role.module')}
                    </label>
                    <Dropdown inputId="newRoleModule" value={values.moduleCode} options={moduleOptions} onChange={(e) => change('moduleCode', e.value)} />
                </div>
                <div className="field col-12 md:col-6">
                    <label htmlFor="newRolePriority" className="font-bold">
                        {th('authorizationV2.role.priority')}
                    </label>
                    <InputNumber inputId="newRolePriority" value={values.priority} onValueChange={(e) => change('priority', e.value ?? 0)} min={0} max={1000} showButtons disabled={!values.moduleCode} />
                </div>
                <div className="field col-12">
                    <label htmlFor="newRoleUserType" className="font-bold">
                        {th('authorizationV2.role.assignableUserType')}
                    </label>
                    <Dropdown inputId="newRoleUserType" value={values.assignableUserType} options={userTypeOptions} onChange={(e) => change('assignableUserType', e.value)} />
                </div>
            </div>
        </Dialog>
    );
};

export default CreateRoleDialog;
